import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { NhanSuService } from '../services/nhan-su.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
  doiMatKhauForm: FormGroup;
  showOldPasswordInput = true;
  @Input() doiMatKhauFlag = false;
  @Input() idUser = -1;
  @Output() hideDialogEvent = new EventEmitter<boolean>();
  position = 'top';
  constructor(private nhanhVienService: NhanSuService,
    private messageService: MessageService) {
    this.doiMatKhauForm = new FormGroup({
      oldPassword: new FormControl(''),
      newPassword: new FormControl(''),
      reNewPassword: new FormControl('')
    });
  }

  ngOnInit(): void {

  }

  checkShowOldPassword(event: any) {
    this.doiMatKhauForm.reset();
    if (this.idUser > 0) {
      this.showOldPasswordInput = false;
    }
    else {
      this.showOldPasswordInput = true;
    }
  }

  dialogHide(event: any) {
    this.hideDialogEvent.emit(false);
  }

  changePassword() {
    if (this.idUser <= 0) {// User hien tai
      if (this.doiMatKhauForm.valid &&
        this.doiMatKhauForm.controls.newPassword.value == this.doiMatKhauForm.controls.reNewPassword.value) {
        let dataPost = {
          oldPassword: this.doiMatKhauForm.controls.oldPassword.value + "",
          newPassword: this.doiMatKhauForm.controls.newPassword.value + "",
          idUser: this.idUser > 0 ? this.idUser : +localStorage.getItem('iduser')!
        };
        this.nhanhVienService.changePassword(dataPost.oldPassword, dataPost.newPassword, dataPost.idUser).subscribe(
          (resp: any) => {
            if (resp != undefined && resp != null) {
              if (resp.flag == 1) {
                this.messageService.add({ severity: 'success', summary: 'Thông báo', detail: 'Đã đổi mật khẩu thành công!' });
                this.doiMatKhauFlag = false;
              }
              else {
                this.messageService.add({ severity: 'error', summary: 'Thông báo', detail: 'Mật khẩu cũ không khớp!' });
              }
            }
          },
          (error: any) => {
            this.messageService.add({ severity: 'error', summary: 'Thông báo', detail: 'Có lỗi khi thực hiện!' });
          }
        );
      }
      else {
        this.messageService.add({ severity: 'error', summary: 'Thông báo', detail: 'Thông tin không chính xác!' });
      }
    }
    else {// User trong danh sach
      if (this.doiMatKhauForm.controls.newPassword.value == "" || this.doiMatKhauForm.controls.reNewPassword.value == ""
        || (this.doiMatKhauForm.controls.newPassword.value != this.doiMatKhauForm.controls.reNewPassword.value)) {
        this.messageService.add({ severity: 'error', summary: 'Thông báo', detail: 'Thông tin không chính xác!' });
      }
      else {
        this.nhanhVienService.setPassword(this.doiMatKhauForm.controls.newPassword.value, this.idUser).subscribe(
          (resp: any) => {
            if (resp != undefined && resp != null) {
              if (resp.flag == 1) {
                this.messageService.add({ severity: 'success', summary: 'Thông báo', detail: 'Đã đổi mật khẩu thành công!' });
                this.doiMatKhauFlag = false;
              }
              else {
                this.messageService.add({ severity: 'error', summary: 'Thông báo', detail: 'Có lỗi khi thực hiện!' });
              }
            }
          }
        );
      }
    }
  }
}
